import { Style } from "@capacitor/status-bar";
import { StatusBar } from "@capacitor/status-bar";
import { isPageWithDarkBackgroundLightIcons, isPageWithLightBackground } from "../actions/router";

class StatusBarManager {
  private static instance: StatusBarManager;
  private prefersDark: boolean = false;

  private constructor() {}

  public static getInstance(): StatusBarManager {
    if (!StatusBarManager.instance) {
      StatusBarManager.instance = new StatusBarManager();
    }
    return StatusBarManager.instance;
  }

  public async updateStatusBar(route: string) {
    const darkBackground = isPageWithDarkBackgroundLightIcons(route);
    const lightBackground = isPageWithLightBackground(route);
    console.log("updateStatusBar page with dark background", darkBackground);
    console.log("updateStatusBar prefersDark", this.prefersDark);
    try {
      // For pages that have a dark background, set Style.Dark for light icons
      if (darkBackground) {
        await StatusBar.setStyle({
          style: darkBackground ? Style.Dark : Style.Light,
        });
      } else if (lightBackground) {
        await StatusBar.setStyle({
          style: Style.Light,
        });
      } else {
        // For pages where background is defined by prefers-dark-mode, use dark mode preference
        await StatusBar.setStyle({
          style: this.prefersDark ? Style.Dark : Style.Light,
        });
      }
    } catch (err) {
    console.error("Failed to set status bar icon color:", err);
    }
  }

  public setPrefersDark(isDark: boolean) {
    console.log("setPrefersDark isDark", isDark);
    this.prefersDark = isDark;
  }
}

export const statusBarManager = StatusBarManager.getInstance();

